/** 表格操作按钮文案 → Element UI 遗留图标类名（由 AppIcon 解析） */
const TABLE_ACTION_ICON_RULES = [
  ['合约缴费', 'el-icon-wallet'],
  ['查看账单与支付记录', 'el-icon-wallet'],
  ['查看充值记录', 'el-icon-coin'],
  ['查看详情', 'el-icon-document'],
  ['查看合同', 'el-icon-document'],
  ['查看权益', 'el-icon-tickets'],
  ['修改设备数', 'el-icon-edit'],
  ['取消全选', 'el-icon-close'],
  ['立即发货', 'el-icon-s-promotion'],
  ['设备业务类型屏蔽', 'el-icon-lock'],
  ['等级价格设置', 'el-icon-coin'],
  ['工单服务价格', 'el-icon-setting'],
  ['产品屏蔽', 'el-icon-lock'],
  ['关联设备', 'el-icon-link'],
  ['分配权限', 'el-icon-s-check'],
  ['添加子级', 'el-icon-circle-plus-outline'],
  ['发起支付', 'el-icon-wallet'],
  ['登记签约', 'el-icon-edit-outline'],
  ['登记进展', 'el-icon-edit-outline'],
  ['总部关闭', 'el-icon-circle-close'],
  ['主动关闭', 'el-icon-circle-close'],
  ['下发指令', 'el-icon-s-promotion'],
  ['关联权益', 'el-icon-connection'],
  ['关联', 'el-icon-link'],
  ['收款记录', 'el-icon-document'],
  ['收款', 'el-icon-wallet'],
  ['退款', 'el-icon-refresh-left'],
  ['充值', 'el-icon-coin'],
  ['作废', 'el-icon-delete'],
  ['权益', 'el-icon-tickets'],
  ['目标设置', 'el-icon-aim'],
  ['恢复合作', 'el-icon-refresh-left'],
  ['加入黑名单', 'el-icon-warning-outline'],
  ['设为已解约', 'el-icon-warning-outline'],
  ['评价', 'el-icon-star-off'],
  ['查看评价', 'el-icon-star-on'],
  ['修改密码', 'el-icon-key'],
  ['下级用户', 'el-icon-user'],
  ['清除', 'el-icon-delete'],
  ['批量删除', 'el-icon-delete'],
  ['查看用户列表', 'el-icon-user'],
  ['查看', 'el-icon-view'],
  ['详情', 'el-icon-view'],
  ['编辑', 'el-icon-edit'],
  ['修改', 'el-icon-edit'],
  ['删除', 'el-icon-delete'],
  ['移除', 'el-icon-delete'],
  ['取消', 'el-icon-close'],
  ['保存', 'el-icon-check'],
  ['确定', 'el-icon-check'],
  ['提交', 'el-icon-check'],
  ['确认', 'el-icon-check'],
  ['上架', 'el-icon-upload2'],
  ['下架', 'el-icon-download'],
  ['复制', 'el-icon-document-copy'],
  ['添加', 'el-icon-circle-plus-outline'],
  ['新增', 'el-icon-circle-plus-outline'],
  ['分配', 'el-icon-s-check'],
  ['派单', 'el-icon-s-promotion'],
  ['结算', 'el-icon-wallet'],
  ['费用支付', 'el-icon-wallet'],
  ['标签', 'el-icon-collection-tag'],
  ['关闭', 'el-icon-close'],
  ['解约', 'el-icon-warning-outline'],
  ['合约续签', 'el-icon-refresh'],
  ['续租', 'el-icon-refresh'],
  ['续约', 'el-icon-refresh'],
  ['续费', 'el-icon-refresh'],
  ['更多', 'el-icon-arrow-down'],
  ['屏蔽', 'el-icon-lock'],
  ['发货', 'el-icon-s-promotion'],
  ['下载', 'el-icon-download'],
  ['导出', 'el-icon-download'],
  ['导入', 'el-icon-upload2'],
  ['审核', 'el-icon-s-check'],
  ['通过', 'el-icon-check'],
  ['驳回', 'el-icon-close'],
  ['启用', 'el-icon-open'],
  ['禁用', 'el-icon-turn-off'],
  ['重置', 'el-icon-refresh-left'],
  ['刷新', 'el-icon-refresh'],
  ['设置', 'el-icon-setting'],
  ['配置', 'el-icon-setting'],
  ['打印', 'el-icon-printer'],
  ['预览', 'el-icon-view'],
]

const DANGER_RE = /\b(btn-danger|btn-danger-text|danger)\b/
const WARNING_RE = /\bwarning\b/
const MORE_RE = /\bbtn-more\b/

export function resolveTableActionIcon(label, attrs = '') {
  const text = String(label || '').trim()
  if (!text) return 'el-icon-more-outline'
  if (MORE_RE.test(attrs)) return 'el-icon-arrow-down'
  if (WARNING_RE.test(attrs)) return 'el-icon-warning-outline'
  if (DANGER_RE.test(attrs) && !/^取消/.test(text)) return 'el-icon-delete'

  for (const [key, icon] of TABLE_ACTION_ICON_RULES) {
    if (text === key) return icon
  }
  for (const [key, icon] of TABLE_ACTION_ICON_RULES) {
    if (text.includes(key)) return icon
  }
  return 'el-icon-more-outline'
}
